define('jquery.tooltip',['jquery', 'fastdom'], function ($, fastdom) {

	/* jQuery Snappet Tooltip v0.1.6
	 * Created by: Paul de Vries 17-11-2015
	 * 
	 * Call methods
	 * - $(element).tooltip("title", { optional: options });
	 * - $(element).tooltip({ options });
	 * 
	 * Options (object)
	 * - title [""] (string)
	 * - debug [true/false] (boolean)
	 * - placement ["top"/"bottom"/"left"/"right"] (string)
	 * - viewport [window] (DOM element)
	 * - disableTouch [true/false] (boolean)
	 * - containment [true/false] (boolean)
	 * - closeOpenTooltips [true/false] (boolean)
	 * - className ["tooltip"] (string)
	 * - appendTo ["body"] (string)
	 * - template ["<div>"] (string)
	 */

	var isTouch = false,
		getInstance = function (fnName, event) {
			var tooltipInstance = $(event.currentTarget).data("tooltip");

			if (tooltipInstance && typeof tooltipInstance[fnName] === "function") {
				tooltipInstance[fnName](event);
			} else {
				$(".tooltip").detach();
			}
		};

	// Check once if user is using a touch device
	$(document).one("touchstart.check.tooltip", function (e) {
		$("html").addClass("isTouch");
		isTouch = true;

		// Remove mouse events
		$(document).off(".mouse.tooltip");
		// Add touch event
		$(document).on("touchstart.tooltip", $.proxy(getInstance, null, "hide"));
	});

	$(document).on("mouseenter.mouse.tooltip", ".isTooltip", $.proxy(getInstance, null, "show"));
	$(document).on("mousemove.mouse.tooltip", ".isTooltip", $.proxy(getInstance, null, "show"));
	$(document).on("mouseleave.mouse.tooltip", ".isTooltip", $.proxy(getInstance, null, "hide"));

	var Tooltips = function (options) {
		this.setOptions(options);

		this.options.$elm.on("remove.tooltip", this.destroy.bind(this));
		this.options.$elm.on("click.tooltip", this.watch.bind(this));
		this.options.$elm.data("tooltip", this).addClass("isTooltip");
	};

	Tooltips.prototype = {
		constructor: Tooltips,

		options: {
			debug: true,
			placement: "top",
			viewport: window,
			containment: true,
			closeOpenTooltips: true,

			hiddenClass: "hidden-calculations",
			disableTouch: true,
			disableDisabled: true,

			appendTo: "body",
			className: "tooltip",
			template: '<div>' +
			'<div class="tooltip-container">' +
			'<div class="tooltip-arrow"></div>' +
			'<div class="tooltip-content"></div>' +
			'</div>' +
			'</div>'
		},

		show: function (event) {
			if (!this.tooltip) {
				this.tooltip = $(this.options.template).addClass(this.options.className);
			}

			if ($(this.tooltip).is(':visible')) {
				if (this.options.debug) {
					console.warn('Tooltip: Stopping display of tooltip because the tooltip is already open.');
				}
				return;
			}

			if (!this.options.title) {

				if (this.options.debug) {
					console.warn("Tooltip: Stopping display of tooltip due to an empty title.");
				}

				// If the event starts with touch, then block the show and block it in the default mouse events if disabled by options
			} else if (isTouch && this.options.disableTouch) {

				if (this.options.debug) {
					console.warn("Tooltip: Stopping display of tooltip due to touch options disabled.");
				}

			} else if (this.options.disableDisabled && this.options.$elm.is(":disabled")) {

				if (this.options.debug) {
					console.warn("Tooltip: Stopping display of tooltip due to a disabled element.");
				}

			} else {

				// Defined tooltip open
				this.options.$elm.addClass("openTooltip");

				// Close open tooltips
				if (this.options.closeOpenTooltips) {
					$(".tooltip:not(.alwaysVisible)").detach();
				}

				// Set title
				var title = this.options.title.replace(/\r?\n/g, '<br>');
				this.tooltip.find(".tooltip-content").html(title);

				var endOffset;
				fastdom.measure(function tooltipMeasurePlacement() {
					// Append to options.element
					this.tooltip.appendTo(this.options.appendTo).addClass(this.options.hiddenClass).attr("style", "");

					if (this.options.$elm.prop("offsetWidth") < this.options.$elm.prop("scrollWidth")) {
						$(this.tooltip).addClass("element-is-ellipsis")
					} else {
						$(this.tooltip).removeClass("element-is-ellipsis");
					}

					// Get placement
					endOffset = this.getPlacement(this.options.$elm[0]);
				}.bind(this));

				fastdom.mutate(function tooltipMutatePlacement() {
					// Apply CSS to placement result
					this.tooltip.css(endOffset);


					// Display the tooltip
					this.tooltip.removeClass(this.options.hiddenClass);

					// Trigger event
					$(document).trigger("tooltip-open.tooltip", this);
				}.bind(this));
			}

		},

		watch: function (event) {

			// If a touch device clicked, then show tooltip
			if (isTouch && event.type === "click") {
				this.show.call(this, event);
			}

			// Move the function call to the end of the runtime (i.e. allow KO bindings to work first)
			setTimeout(function () {

				// If element has been disabled (e.g. no more mouseleave triggered)
				if (this.options.$elm.is(":disabled")) {
					this.hide.call(this);
				}

			}.bind(this), 0);

		},

		hide: function () {

			fastdom.mutate(function () {
				// Defined tooltip not open
				this.options.$elm.removeClass("openTooltip");

				if (this.tooltip) {
					// Remove tooltip
					this.tooltip.detach();
				}

				// Trigger event
				$(document).trigger("tooltip-hide.tooltip", this);
			}.bind(this));

		},

		destroy: function () {

			// Hide tooltip
			this.hide();

			// Remove events based on namespace
			this.options.$elm.off(".tooltip");

			// Remove data
			this.options.$elm.removeData("tooltip").removeClass("isTooltip openTooltip");

			// Trigger event
			$(document).trigger("tooltip-destroy.tooltip", this);

		},

		getPlacement: function (elm, placement, preventReplacement) {

			// Use default placement or use the overwritten one
			placement = placement || this.options.placement;
			preventReplacement = preventReplacement + 1 || 0;

			// Unset and set arrow and styles for new calculations
			this.tooltip.attr("style", "").removeClass("top bottom left right").addClass(placement);

			// Get basic offset and width/heights
			var elmRect = elm.getBoundingClientRect(),
				tipRect2 = this.tooltip[0].getBoundingClientRect(),
				left, top;

			var pos = {
				left: elmRect.left + $(window).scrollLeft(),
				top: elmRect.top + $(window).scrollTop()
			}

			// Store getBoundingClientRect to a non-reference object (e.g. IE11)
			var tipRect = $.extend({}, tipRect2);

			// Prevent subpixels from generating incorrect width (e.g. IE9)
			tipRect.width = tipRect.width + 2;

			// Calculate placement
			if (placement == "bottom" || placement == "top") {

				// Center tooltip horizontal
				left = (pos.left + (elmRect.width / 2)) - (tipRect.width / 2);

				// Set position to element
				top = (placement == "bottom") ? (pos.top + elmRect.height) : top;
				top = (placement == "top") ? (pos.top - tipRect.height) : top;

			} else if (placement == "left" || placement == "right") {

				// Center tooltip vertical
				top = (pos.top + (elmRect.height / 2)) - (tipRect.height / 2);

				// Set position to element
				left = (placement == "right") ? (pos.left + elmRect.width) : left;
				left = (placement == "left") ? (pos.left - tipRect.width) : left;

			}

			// Overwrite position if it's outside the containment area
			if (this.options.containment && preventReplacement < 5) {
				var viewport = {};

				// If viewport is window do not use getBoundingClientRect
				if (this.options.viewport !== window) {
					viewport = $(this.options.viewport)[0].getBoundingClientRect();
				} else {
					viewport = {
						left: $(this.options.viewport).scrollLeft(),
						top: $(this.options.viewport).scrollTop(),
						width: $(this.options.viewport).innerWidth(),
						height: $(this.options.viewport).innerHeight()
					}
				}

				// Right position is outside the viewport; try using left position
				if (left + tipRect.width > viewport.width + viewport.left) {
					return this.getPlacement(elm, "left", preventReplacement);
				}
				// Left position is outside the viewport; try using right position
				if (left < viewport.left) {
					return this.getPlacement(elm, "right", preventReplacement);
				}
				// Bottom position is outside the viewport; try using top position
				if (top + tipRect.height > viewport.height + viewport.top) {
					return this.getPlacement(elm, "top", preventReplacement);
				}
				// Top position is outside the viewport; try using bottom position
				if (top < viewport.top) {
					return this.getPlacement(elm, "bottom", preventReplacement);
				}

			} else if (preventReplacement === 5) {

				// No replacement found, use orignal placement
				return this.getPlacement(elm, this.options.placement, preventReplacement);

			}

			return {
				left: left,
				top: top,
				width: tipRect.width,
				height: tipRect.height
			}

		},

		showBy: function ($elm) {

			this.options.$elm = $elm;
			this.show();

		},

		// Overwrite options
		setOptions: function (options) {

			var disableTouch = {
				disableTouch: (options.touch === true) ? false : this.options.disableTouch
			}
			return this.options = $.extend({}, this.options, options, disableTouch);

		}

	};

	$.fn.tooltip = function () {
		var options = {};

		if (arguments.length > 1) {
			options = arguments[1];
			options.title = arguments[0] || "";
		} else if (typeof arguments[0] !== "string") {
			options = arguments[0] || {};
		} else {
			options.title = arguments[0] || "";
		}

		options.$elm = this;

		if (!options.$elm.data("tooltip")) {
			return new Tooltips(options);
		} else {
			options.$elm.data("tooltip").setOptions(options);
			return options.$elm.data("tooltip");
		}
	};

	$.fn.tooltip.Constructor = Tooltips;

});
